import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasAuthority from './aidas-authority';
import AidasAuthorityDetail from './aidas-authority-detail';
import AidasAuthorityUpdate from './aidas-authority-update';
import AidasAuthorityDeleteDialog from './aidas-authority-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasAuthorityUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasAuthorityUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasAuthorityDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasAuthority} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasAuthorityDeleteDialog} />
  </>
);

export default Routes;
